// extracted by mini-css-extract-plugin
module.exports = {"container":"Map_container__3KtQ4","heading":"Map_heading__17bnF","address":"Map_address__3cUsz","googleMap":"Map_googleMap__34zdP"};